import * as XLSX from 'xlsx';

/**
 * Download rows as an .xlsx file.
 * @param {Array<object>} rows - source records
 * @param {Array<{header: string, value: (row) => any, width?: number}>} columns
 * @param {string} filename - without extension
 * @param {string} sheetName
 */
export function exportToExcel(rows, columns, filename, sheetName = 'Sheet1') {
    const data = rows.map((row) =>
        Object.fromEntries(columns.map((col) => [col.header, col.value(row) ?? '']))
    );
    const worksheet = XLSX.utils.json_to_sheet(data, { header: columns.map((c) => c.header) });
    worksheet['!cols'] = columns.map((c) => ({ wch: c.width || 18 }));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31));
    XLSX.writeFile(workbook, `${filename}.xlsx`);
}

export const CELL_EXPORT_COLUMNS = [
    { header: 'Name', value: (c) => c.name, width: 24 },
    { header: 'Address', value: (c) => c.address, width: 32 },
    { header: 'City', value: (c) => c.city },
    { header: 'Cell Leader', value: (c) => c.CellLeader?.name, width: 22 },
    { header: 'Cell Type', value: (c) => c.cell_type },
    { header: 'Meeting Day', value: (c) => c.meeting_day, width: 14 },
    { header: 'Meeting Time', value: (c) => c.meeting_time, width: 14 },
    { header: 'Latitude', value: (c) => c.latitude, width: 12 },
    { header: 'Longitude', value: (c) => c.longitude, width: 12 },
];
